<template>
  <div class="d-flex flex-column g-4">
    <InputView type="text" :placeholder="translate('search')" v-model:value="query" focus/>
    <div v-for="module in results.filter(item => item.results.length > 0)" :key="module.key" class="d-flex flex-column g-2">
      <h3 class="mb-0">{{ module.name }}</h3>
      <div class="list-group">
        <div v-for="(result, index) in module.results" :key="index" class="list-group-item list-group-item-action" @click="emit('dismiss'); router.push(result.route)">
          <div class="d-flex align-items-center text-left g-3 w-100">
            <div v-if="result.avatar || result.icon || result.color" style="font-size: 1.4em">
              <AvatarView v-if="result.avatar" :url="result.avatarUrl"/>
              <i v-else-if="result.icon || result.color" :class="result.icon ?? 'fas fa-circle'" :style="result.color ? ('color: ' + result.color) : ''" style="width: 1em"></i>
            </div>
            <div class="d-flex flex-column g-1">
              <div class="text-break" style="font-size: 0.95em">{{ result.title }}</div>
              <div v-if="result.subtitle" style="font-size: 0.8em" class="d-flex align-items-center g-1">
                <i v-if="result.subtitle.icon" :class="result.subtitle.icon" class="fa-fw"></i>
                <span class="text-break text-muted font-weight-normal">{{ result.subtitle.content }}</span>
              </div>
            </div>
            <TooltipView class="ms-auto">
              <template v-slot:target>
                <i :class="result.type.icon" class="me-2 fa-fw" style="font-size: 0.8em"></i>
              </template>
              <template v-slot:body>
                {{ result.type.name }}
              </template>
            </TooltipView>
          </div>
        </div>
        <div v-if="results.length === 0">
          {{ translate("no.results") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {InputView, toasts, TooltipView, utilities} from "@/niftybit";
import {ref, watch} from "vue";
import {useRouter} from "vue-router";
import AvatarView from "@/components/global/AvatarView.vue";
import axios from "axios";

const props = defineProps({
  communityId: String
});

const emit = defineEmits(["dismiss"]);

const query = ref("");
const router = useRouter();
const results = ref([]);
let searchTimeout = undefined;

function load() {
  axios.get(utilities.path("communities/@/search", props.communityId), { params: { query: query.value } }).then(response => {
    results.value = response.data;
  }).catch(error => {
    toasts.create({
      color: "danger",
      content: "Search failed (status " + error.response?.status + ")."
    });
  });
}

watch(query, () => {
  if (searchTimeout) clearTimeout(searchTimeout);
  searchTimeout = setTimeout(() => {
    load(query.value);
  }, 300);
});

</script>